// src/redux/reducers/siteReducer.js
// import { SET_UI_FEATURE } from "../actions/alerttrendAtion";

import { SET_FEATURE_ACCESS } from "../actions/featureListAction";

const initialState = {
    featureaccess: [],
};

const featureListReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FEATURE_ACCESS:
      return {
        ...state,
        featureaccess: action.payload,
      };
    default:
      return state;
  }
};

export default featureListReducer;
